import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoginService } from '../services/login.service'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styles: [`
  .error {
      background-color: #fff0f0
  }
`]
})
export class LoginComponent implements OnInit {
  //form;
  clickStatus = false;
  msg = '';

  constructor(public ls: LoginService,private router: Router) { 
    /*this.form = fb.group({
      employee_code : ['',Validators.compose([Validators.required,Validators.minLength(3)])],
      password : ['',Validators.required]
    })*/
    
  }
  loginData = {
    employee_code: '',
    password: ''
}

  ngOnInit() {
  }

  onSubmit(loginForm)
  {
    this.clickStatus = true;
    if(loginForm.valid)
    {
      var result = this.ls.login(this.loginData).subscribe( res => {
        //console.log(res);
        if(!res.token)
        {
            this.msg = res.message;
            return;
        }
        else if(res.change_pwd=='no')
        {
          this.ls.authenticate(res);
          this.router.navigate(['/change_pwd']);
        }
        else{
          this.ls.authenticate(res);
          this.router.navigate(['/dashboard']);
        }
        
      })
      //console.log(result);
    }
   
   
  }
  isValid(control) {
    //return this.form.controls[control].invalid && this.form.controls[control].touched
}

}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts